import { combineReducers } from 'redux';
import { accountsReducer } from './accountsReducer';
import { cardsReducer,
  cardDetailReducer,
  activateCardReducer,
  activateMultipleCardsReducer,
  setCardUsageOptionsReducer,
  setCardStatusReducer,
  setMultipleCardStatusReducer,
  editMultipleCardDetailReducer,
  getCardAccountDefaultReducer
} from './cardsReducer';
import { rolesReducer, assignableRolesReducer } from './rolesReducer';
import { usersReducer } from './usersReducer';
import transactionReducer from './transactionReducers';
import { notificationsReducer } from './notificationsReducer';
import { getCardOptionsReducer, getVehicleTypeReducer, createCardOptionsReducer, updateCardOptionsReducer, storeReducer } from './storeReducer';
import billingReducer from './billingReducer';
import { reportsReducer } from './reportsReducer';
import { maintenanceReducer, scheduledMaintenanceReducer } from './maintenanceReducer';
import { accountingIntegrationReducer } from './accountingIntegrationReducer';
import { everydayRewardsReducer } from './everydayRewardsReducer';
import { cashReducer } from './cashReducer';
import { modalMetaReducer } from 'reducers/modalMetaReducer';
import { toastAlertReducer } from './toastAlertReducer';
import { cardFormReducer } from 'features/cards/components/new-card-modal/multi-edit-card-modal/MutliEditCardFormSlice';
import { configureStore } from '@reduxjs/toolkit';

// TODO: Start using the below naming convention for all stores
// using [name]Store as naming convention to handle collisions with local state.[name] scenarios
const rootReducer = combineReducers({
  cardsStore: cardsReducer,
  accountsStore: accountsReducer,
  cardDetailView: cardDetailReducer,
  userStore: usersReducer,
  rolesList: rolesReducer,
  assignRolesList: assignableRolesReducer,
  transactionsStore: transactionReducer,
  billingView: billingReducer, // TODO: Combine into other reducers
  notifications: notificationsReducer,
  getCardOptions: getCardOptionsReducer,
  getVehicleTypes: getVehicleTypeReducer,
  createCardOptions: createCardOptionsReducer,
  updateCardOptions: updateCardOptionsReducer,
  activateCard: activateCardReducer,
  activateMultipleCards: activateMultipleCardsReducer,
  cardUsageOptions: setCardUsageOptionsReducer,
  setSingleCardStatus: setCardStatusReducer,
  setMultipleCardStatus: setMultipleCardStatusReducer,
  editMultipleCardDetail: editMultipleCardDetailReducer,
  accountDefaults: getCardAccountDefaultReducer,
  reportsStore: reportsReducer,
  dataStore: storeReducer,
  maintenanceStore: maintenanceReducer,
  scheduledMaintenanceStore: scheduledMaintenanceReducer,
  accountingIntegrationStore: accountingIntegrationReducer,
  everydayRewardsStore: everydayRewardsReducer,
  cashStore: cashReducer,
  modalStore: modalMetaReducer,
  toastAlertStore: toastAlertReducer,
  cardFormStore: cardFormReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof store.getState>;